/*
  Shared live-GPS helper. Fetches the latest truck ping from the Apps Script
  endpoint and hands it to whichever section asked. Cached for 2 minutes per
  session so multiple sections on one page cost one request.
  window.wbLiveGps(url, staleMinutes, callback) -> callback(pingOrNull)
*/
(function () {
  'use strict';
  var CACHE_KEY = 'wbLiveGpsCache';
  var CACHE_MS = 2 * 60 * 1000;
  var inflight = null;
  var waiters = [];

  function fresh(ping, staleMinutes) {
    if (!ping || ping.lat === null || ping.lng === null || !ping.ts) { return null; }
    var age = (Date.now() - new Date(ping.ts).getTime()) / 60000;
    if (isNaN(age) || age > staleMinutes) { return null; }
    ping.ageMinutes = Math.round(age);
    return ping;
  }

  window.wbLiveGps = function (url, staleMinutes, cb) {
    if (!url || !window.fetch) { cb(null); return; }
    try {
      var raw = window.sessionStorage.getItem(CACHE_KEY);
      if (raw) {
        var obj = JSON.parse(raw);
        if (obj.url === url && (Date.now() - obj.at) < CACHE_MS) {
          cb(fresh(obj.ping, staleMinutes));
          return;
        }
      }
    } catch (e) {}

    waiters.push(function (ping) { cb(fresh(ping, staleMinutes)); });
    if (inflight) { return; }
    inflight = true;

    fetch(url, { credentials: 'omit', redirect: 'follow' })
      .then(function (res) { if (!res.ok) { throw new Error('bad'); } return res.json(); })
      .then(function (ping) {
        try { window.sessionStorage.setItem(CACHE_KEY, JSON.stringify({ url: url, at: Date.now(), ping: ping })); } catch (e) {}
        var w = waiters; waiters = []; inflight = null;
        for (var i = 0; i < w.length; i++) { w[i](ping); }
      })
      .catch(function () {
        var w = waiters; waiters = []; inflight = null;
        for (var i = 0; i < w.length; i++) { w[i](null); }
      });
  };
})();
